module.exports = __webpack_public_path__ + "static/teaser-5e9fbb780b99dc7fd93d193ce4f0deb7.gif";